/* Cell Devices — one disclosure contract for every FAQ accordion (WEB-020, 2026-09-19).
   Eight sections each carry their own FAQ toggle (repairs, the device/family repair pages, trade-in, the
   contact and info pages, the three fault pages, and the quote calculator). All of them open and close by
   adding/removing an `open` class on the item, and none told assistive technology anything: no
   aria-expanded, no link from the question to its answer. Rather than patch eight copies, this file gives
   every one the same contract without touching how they toggle:
     · each question button gets aria-controls pointing at its answer (an id is added if missing);
     · aria-expanded always mirrors the item's `open` class — set on load, and kept true by watching the
       class, so a toggle that opens one item and closes the others updates every button it touched.
   Progressive enhancement only: without this file the accordions work exactly as before. */
(function () {
  'use strict';
  var QUESTION = '.cdr-faq__q, .cddev-faq__q, .cdt-faq__q, .cdfp-faq__q, .cdmc-faq__q';
  var seq = 0;

  function itemOf(btn) {
    return btn.closest('.cdr-faq__item, .cddev-faq__item, .cdt-faq__item, .cdfp-faq__item, .cdmc-faq__item') || btn.parentElement;
  }
  function answerOf(btn, item) {
    var a = btn.nextElementSibling;
    if (a && /-faq__a\b/.test(a.className)) return a;
    return item ? item.querySelector('[class*="-faq__a"]') : null;
  }
  function sync(btn, item) {
    btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
  }
  function wire(btn) {
    if (btn.getAttribute('data-cd-disclosure') === '1') return;
    var item = itemOf(btn);
    if (!item) return;
    btn.setAttribute('data-cd-disclosure', '1');
    var answer = answerOf(btn, item);
    if (answer) {
      if (!answer.id) answer.id = 'cd-faq-answer-' + (++seq);
      btn.setAttribute('aria-controls', answer.id);
    }
    sync(btn, item);
    if (window.MutationObserver) {
      new MutationObserver(function () { sync(btn, item); })
        .observe(item, { attributes: true, attributeFilter: ['class'] });
    }
  }
  function scan() {
    var list = document.querySelectorAll(QUESTION);
    for (var i = 0; i < list.length; i++) wire(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // A section re-rendered by the theme editor arrives as new markup; wire it too (already-wired buttons skip).
  document.addEventListener('shopify:section:load', scan);
})();
